let toastTimer = null

function clearToastNode() {
  const old = document.querySelector('.toast')
  if (old && old.parentNode) {
    old.parentNode.removeChild(old)
  }
}

/** Normalize API/vendor error payloads into a short user-facing string */
export function formatApiErrorMessage(raw, fallback = 'Gagal memproses permintaan') {
  if (raw == null || raw === '') return fallback
  let text = String(raw).trim()
  if (!text) return fallback

  // Vendor sometimes returns JSON string as message, e.g. {"Data":null,"ErrorCode":-2000,...}
  if (text.charAt(0) === '{' && text.indexOf('ErrorCode') !== -1) {
    try {
      const obj = JSON.parse(text)
      const code = obj.ErrorCode != null ? obj.ErrorCode : obj.errorCode
      const msg =
        obj.Message ||
        obj.message ||
        obj.Msg ||
        obj.msg ||
        obj.ErrorMessage ||
        obj.errorMessage ||
        ''
      if (msg && String(msg).trim()) {
        text = String(msg).trim()
      } else if (code === -2000 || code === '-2000') {
        text = 'Gagal masuk game. Silakan coba lagi nanti atau pilih game lain.'
      } else if (code != null && code !== '') {
        text = `Gagal masuk game (kode ${code}). Silakan coba lagi.`
      } else {
        text = 'Gagal masuk game. Silakan coba lagi nanti.'
      }
    } catch (e) {
      text = 'Gagal masuk game. Silakan coba lagi nanti.'
    }
  }

  if (text.length > 160) {
    text = text.slice(0, 157) + '...'
  }
  return text
}

function renderToast(message, type = 'success', duration = 2200) {
  if (typeof document === 'undefined') return
  const text = formatApiErrorMessage(message, type === 'success' ? '' : 'Error')
  if (!text) return

  if (toastTimer) {
    window.clearTimeout(toastTimer)
    toastTimer = null
  }
  clearToastNode()

  const toast = document.createElement('div')
  toast.className = `toast toast-${type}`
  toast.style.left = '50%'
  toast.style.transform = 'translateX(-50%)'

  const contain = document.createElement('div')
  contain.className = 'toast-contain'
  contain.textContent = text
  toast.appendChild(contain)

  document.body.appendChild(toast)
  window.requestAnimationFrame(() => {
    toast.style.top = '2rem'
  })

  toastTimer = window.setTimeout(() => {
    toast.style.top = '-7.2rem'
    window.setTimeout(() => {
      clearToastNode()
    }, 420)
  }, duration)
}

export function toastSuccess(message, duration) {
  renderToast(message, 'success', duration)
}

export function toastError(message, duration) {
  renderToast(message, 'error', duration)
}

export function toastWarn(message, duration) {
  renderToast(message, 'warn', duration)
}

